import { useEffect, useState } from 'react';
import { Container, Form, Button, Row, Col, Spinner } from 'react-bootstrap';
import { useSendContactEmailMutation } from '../slices/emailApiSlice';
import { toast } from 'react-toastify';
import { FaWhatsapp, FaPhone } from "react-icons/fa";

const ContactScreen = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [sendContactEmail, { isLoading, isError, error }] = useSendContactEmailMutation();

  useEffect(() => {
    if (submitted) {
      toast.success("Thank you for contacting us. We'll respond soon.", {autoClose: 1000});
      setSubmitted(false); // Reset submitted after showing toast
    }
  }, [submitted]);

  useEffect(() => {
    if (isError && error) {
      toast.error(error?.data?.message || "Failed to send email.", {autoClose: 2000});
    }
  }, [isError, error]);

  const whatsappContact = "919390595210"
  const whatsappMessage = "Hi, I have the following enquiry.";
  const whatsappUrl = `https://wa.me/${whatsappContact}?text=${encodeURIComponent(whatsappMessage)}`;

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await sendContactEmail(formData).unwrap();
      setSubmitted(true);
      setFormData({ name: '', phone: '', email: '', subject: '', message: '' });
    } catch (err) {
      console.error('Email send failed:', err);
    }
  };

  return (
    <Container className="py-2">
      <h3>
        Contact on WhatsApp - &nbsp;
        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
          <FaWhatsapp style={{ color: 'green', fontSize: '2rem', fontStyle: "bold" }}/>
        </a>
      </h3>
      <h3>
        Contact on Phone - &nbsp;
        <a href="tel:+919390595210" style={{ textDecoration: 'none' }}>
          <FaPhone style={{ color: 'blue', fontSize: '2rem', fontStyle: "bold" }}/>
        </a>
      </h3>
      <h3>Contact Form</h3>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>Name <span className="text-danger"><strong>*</strong></span></Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3" controlId="phone">
              <Form.Label>Phone <span className="text-danger"><strong>*</strong></span></Form.Label>
              <Form.Control
                type="text"
                inputMode="numeric"
                pattern="[1-9][0-9]{9}"
                placeholder="Enter valid 10 digit phone number"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3" controlId="subject">
          <Form.Label>Subject</Form.Label>
          <Form.Control
            type="text"
            placeholder="Subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="message">
          <Form.Label>Message <span className="text-danger"><strong>*</strong></span></Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            placeholder="Write your message here..."
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Button
          variant="primary"
          type="submit"
          disabled={isLoading || (!formData.name || !formData.phone || !formData.message)}
        >
          {isLoading ? (
            <>
              <Spinner animation="border" size="sm" /> Sending...
            </>
          ) : (
            "Send Message"
          )}
        </Button>
      </Form>
    </Container>
  );
};

export default ContactScreen;